export enum JournalEditMode {
	create = 'create',
	edit = 'edit',
	duplicate = 'duplicate'
}
